import script from "./esCalendarMainSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esCalendarMainSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esCalendarMainSettings.vue?vue&type=style&index=0&id=184acc36&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184acc36"]])

export default __exports__